var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"card min-height",attrs:{"fluid":"","align":"center","id":"containerCanvas"}},[_c('v-row',{staticClass:"d-flex justify-center"},[_c('v-col',[_c('canvas',{attrs:{"id":"canvas_automata"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }